module.exports = __webpack_public_path__ + "static/media/Analysis Paralysis, Choice Overload - victoriano-izquierdo-JG35CpZLfVs-unsplash.148cf1cf.jpg";